import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedSeating } from "./seating.query";


export interface TypedJourney {
    id?: string | bigint;
    journey_name?: string;
    journey_description?: string;
    journey_distance?: number;
    journey_from?: string;
    journey_from_geo?: string;
    journey_to?: string;
    journey_to_geo?: string;
    journey_status?: number;
    journey_total_time?: number; /** Số phút thực hiện được hành trình này */
    journey_default_price?: number; /** giá mặc định */
    journey_default_seating?: string;
    journey_parent?: bigint | null;
    is_default?: number;
    createdAt?: string | bigint;

    seating?: TypedSeating,
}



type IQuery = TypedJourney & IQueryParams;


/*
* List of all app
*/
export function useGetJourneys(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["journey/fetch_entity_list"],
        queryFn: () => axios.get<TypedJourney[]>(`/journey${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: true,
    });
}



export function useGetJourney(journey_id: string) {
    return useQuery({
        queryKey: ['journey/fetch_entity', journey_id],
        queryFn: () => axios.get<TypedJourney>(`/journey/${journey_id}`).then((response) => response.data),
        retry: 1,
        refetchOnReconnect: false,
        // enabled: false,
    });
}


export function useMutateGetJourneys() {
    return useMutation({
        mutationKey: ['journey/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedJourney[]>(`/journey/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetJourney() {
    return useMutation({
        mutationKey: ['journey/fetch_entity'],
        mutationFn: (journey_id: any) => axios.get<TypedJourney>(`/journey/${journey_id}`).then((response) => response.data),
    });
}


export function useUpdateJourney() {
    return useMutation({
        mutationKey: ['journey/update_entity'],
        mutationFn: ({ id, ...rest }: TypedJourney) => axios.patch<TypedJourney>(`/journey/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['journey/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['journey/fetch_entity'] });
        }
    });
}


export function useMutateCreateJourney() {
    return useMutation({
        mutationKey: ['journey/create_entity'],
        mutationFn: (entity: TypedJourney) => axios.post<TypedJourney>(`/journey`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['journey/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['journey_stage/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteJourney() {
    return useMutation({
        mutationKey: ['journey/create_entity'],
        mutationFn: (id: any) => axios.delete<TypedJourney>(`/journey/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['journey/fetch_entity_list'] });
        }
    });
}

